import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Store } from 'components/common/types/Store.types';
import { DealStatus, FrontEndType } from 'components/common/types/Deal.types';
import { isDirectSalesCampaignCloned } from 'components/pages/Planner/hooks/utils/isDirectSalesCampaignCloned';
import { getIsDirectSalesCampaignType } from 'store/dealManagement/selectors/getCampaignType';
import { getIsReseller } from 'store/publisher/selectors';
import { getDealId, getDisplayCampaignId } from 'store/dealManagement/selectors/getDealId';
import CampaignId from './CampaignId';
import CampaignName from './CampaignName';
import CampaignBookingStatus from './CampaignBookingStatus';
import { useCampaignNameAutoFocus, UseCampaignNameOptions } from './useCampaignNameAutoFocus';

export interface OverviewProps {
  campaignView: FrontEndType;
  campaignNameOptions?: UseCampaignNameOptions;
  saveDeal: (bookingStatusCode: DealStatus | null, catchHandler?: (() => void) | undefined) => void;
}

const Overview: React.FC<OverviewProps> = ({ campaignView, campaignNameOptions, saveDeal }) => {
  const { inputRef, isDisabled, onBlur } = useCampaignNameAutoFocus(campaignNameOptions);

  const dealName = useSelector((state: Store) => state.dealManagement.commonDeal.dealName);
  const dealId = useSelector(getDealId);
  const displayCampaignId = useSelector(getDisplayCampaignId);
  const isReseller = useSelector(getIsReseller);

  const isDirectSalesCampaignType = useSelector(getIsDirectSalesCampaignType);

  const { campaignId: originalCampaignId } = useParams();

  const campaignId = isDirectSalesCampaignCloned(dealId) ? originalCampaignId : displayCampaignId;

  return (
    <div className="grid grid-cols-1 pt-[3px] pr-[16px] pb-[8px] pl-[14px]" data-test-id="drawer-overview">
      <div className="pl-[2px]">
        <CampaignName campaignName={dealName} isDisabled={isDisabled} ref={inputRef} onBlur={onBlur} />
      </div>
      <div className="pl-[8px] pt-[2px]">
        <CampaignId campaignId={campaignId} />
      </div>
      <div className="pl-[8px] pt-[6px]">
        {!isDirectSalesCampaignType && (campaignView === FrontEndType.STANDARD || !isReseller) && (
          <CampaignBookingStatus onConfirm={saveDeal} />
        )}
      </div>
    </div>
  );
};

export default Overview;
